import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Context } from "../../../../Context/PermissoesContext";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";

import Paper from "../../../../componentsv2/Paper";
import Box from "../../../../componentsv2/Box";
import Button from "../../../../componentsv2/Button";
import { Input } from "../../../../componentsv2/Input";
import { useSnackbar } from "notistack";

export default function Cabecalho({ busca, setBusca }) {
  const history = useHistory();
  const { checarPermissao } = useContext(Context);
  const { enqueueSnackbar } = useSnackbar();

  const handleCadastrar = async () => {
    try {
      if (!checarPermissao("GDC002")) {
        return enqueueSnackbar("Erro! Você não tem permissão para cadastrar cliente!", {
          variant: "error",
        });
      }
      history.push({
        pathname: "/GestaoDeClientes/CadastroDeClientes",
      });
    } catch (error) {}
  };

  return (
    <Paper style={{ padding: "1rem" }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "minmax(280px, 1fr) 180px" },
          gap: 2,
          alignItems: "end",
        }}
      >
        <Input
          label="Pesquisar cliente"
          variant="standard"
          fullWidth
          value={busca}
          onChange={event => setBusca(event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "#8a919b" }} />
              </InputAdornment>
            ),
          }}
        />
        <Button variant="contained" color="blue" fullWidth onClick={handleCadastrar}>
          Cadastrar Cliente
        </Button>
      </Box>
    </Paper>
  );
}
